/** @jsx jsx */

import Button from '@datacamp/waffles-button';
import { VideoCameraIcon } from '@datacamp/waffles-icons';
import { jsx } from '@emotion/react';
import React from 'react';
import { VideoDialog } from './VideoDialog';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const VideoResource = _ref => {
  let {
    label,
    url
  } = _ref;
  const [videoDialogOpen, setVideoDialogOpen] = React.useState(false);
  const openVideoDialog = React.useCallback(() => setVideoDialogOpen(true), []);
  const closeVideoDialog = React.useCallback(() => setVideoDialogOpen(false), []);
  return jsx(React.Fragment, null, jsx(Button, {
    dataAttributes: {
      cy: 'video-resource'
    },
    onClick: openVideoDialog,
    size: "small"
  }, jsx(VideoCameraIcon, null), " ".concat(label !== null && label !== void 0 ? label : 'Last video')), videoDialogOpen && jsx(VideoDialog, {
    onExit: closeVideoDialog,
    videoUrl: url
  }));
};